import { render, staticRenderFns } from "./SetNumPeopleAva.vue?vue&type=template&id=f316b590"
import script from "./SetNumPeopleAva.vue?vue&type=script&lang=js"
export * from "./SetNumPeopleAva.vue?vue&type=script&lang=js"
import style0 from "./SetNumPeopleAva.vue?vue&type=style&index=0&id=f316b590&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports